import "./Step.css";
interface IStepProps {
  image: string;
  doneImage: string;
  children: JSX.Element | string;
  active?: boolean;
  done?: boolean;
}

const Step = ({ image, doneImage, children, active, done }: IStepProps) => {
  const getClasses = () => {
    if (done) {
      return "grey";
    } else if (active) {
      return "red bold2 stepBig";
    }
    return "";
  };

  return (
    <div className="stepContainer">
      <p className={`step stepText2 ${getClasses()}`}>{children}</p>
      <img src={done ? doneImage : image} width="40" height="40" alt="" />
    </div>
  );
};

export { Step };
